import { IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import badges from "wwwroot/json/badges.json";
import { IIndicator } from "@gtmhub/error-handling";
import { IBadge } from "../models/badges";
import { BadgeService } from "../services/badges";

interface IBadgeTemplatesScope extends IScope {
  installed: number;
  indicators: {
    installing?: IIndicator;
  };
  badges: IBadge[];
  install(): void;
}

export class BadgeTemplatesCtrl {
  public static $inject = ["$scope", "$state", "BadgeService"];

  constructor(private $scope: IBadgeTemplatesScope, private $state: StateService, private badgeService: BadgeService) {
    this.$scope.install = this.install;
    this.$scope.installed = 0;
    this.$scope.indicators = {};
    this.$scope.badges = badges;
  }

  private install = () => {
    this.$scope.indicators.installing = { progress: true };
    for (let i = 0; i < this.$scope.badges.length; i++) {
      this.badgeService.createBadge(this.$scope.badges[i]).then(() => {
        this.$scope.installed++;

        if (this.$scope.installed === this.$scope.badges.length) {
          delete this.$scope.indicators.installing;
          this.$state.go("^.^");
        }
      });
    }
  };
}
